<template>
<div class="container">
  <Header />
  <b-card no-body>
    <b-tabs card>
      <b-tab title="ユーザー一覧" active>
        <p>空蝉に登録されているユーザーです。</p>
        <b-table striped hover responsive :items="userList" :fields="fields">
          <template v-slot:[`cell(authorized)`]="data">
            <b-form-checkbox v-if="data.item.email!==auth.currentUser.email" v-model="data.value" name="check-button" switch @change="updateAuthorized(data.item.key,data.value)"></b-form-checkbox>
            <b-form-checkbox v-else v-model="data.value" name="check-button" switch @change="updateAuthorized(data.item.key,data.value)" disabled></b-form-checkbox>
          </template>
          <template v-slot:[`cell(lastUpdateDate)`]="data">
            {{data.value | unixtimeToDate}}
          </template>
        </b-table>
      </b-tab>
      <b-tab title="名前候補">
        <p>対戦記録を入力するときの名前候補を編集できます。<br>人を追加したい場合：<br>「メンバー」で「新規登録」を選択</p>
        <validation-observer ref="obs" v-slot="ObserverProps">
          <b-form>
            <b-form-group label="入会年度">
              <b-form-select v-model="meiboYear" :options="meiboYearList" @change="setMemberListByYear(meiboYear)"></b-form-select>
            </b-form-group>
            <!--        <b-form-group label="メンバー" description="、か, か改行で区切ってください">
          <b-form-textarea rows="1" max-rows="10" v-model="memberListByYear"></b-form-textarea>
        </b-form-group>-->
            <b-form-group label="メンバー">
              <b-form-select v-model="selectedMember" :options="nameOptions" @change="setMeiboData(meiboYear,selectedMember)"></b-form-select>
            </b-form-group>
            <validation-provider name="editingComment" rules="required">
              <b-form-group v-if="selectedMember == '新規登録'" label="名前" description="必ず入力してください">
                <b-form-input v-model="memberName"></b-form-input>
              </b-form-group>
            </validation-provider>
            <b-form-group label="かな">
              <b-form-input v-model="memberKana"></b-form-input>
            </b-form-group>
            <b-form-group label="段級位">
              <b-form inline>
                <b-form-select v-model="memberKyu" :options="kyuOptions" style="width:auto"></b-form-select>
                <label for="inline-form-input-kyu" class="my-auto">級</label>
                <b-form-select v-model="memberDan" :options="danOptions" style="width:auto"></b-form-select>
                <label for="inline-form-input-dan" class="my-auto">段</label>
              </b-form>
            </b-form-group>
            <b-form-group>
              <b-button size="sm" variant="success" class="my-2 mx-2 float-right" v-if="selectedMember == '新規登録'" @click="updateMemberObject(meiboYear,memberName)" :disabled="ObserverProps.invalid">追加</b-button>
              <b-button size="sm" variant="success" class="my-2 mx-2 float-right" v-else @click="updateMemberObject(meiboYear,memberName)">更新</b-button>
              <b-button variant="outline-danger" class="my-2 mx-2 float-right" size="sm" @click="$bvModal.show('remove')" v-if="selectedMember != '新規登録'">削除</b-button>
            </b-form-group>

            <b-form-group label="入会年度を追加/削除する">
              <b-form-input v-model="addYear"></b-form-input>
            </b-form-group>
            <b-form-group>
              <b-button size="sm" variant="success" class="my-2 mx-2 float-right" @click="addYearToMemberObject(addYear)">追加</b-button>
              <b-button size="sm" variant="outline-danger" class="my-2 mx-2 float-right" @click="removeYearFromMemberObject(addYear)">削除</b-button>
            </b-form-group>
          </b-form>
        </validation-observer>
      </b-tab>
    </b-tabs>
  </b-card>

  <b-modal v-bind:id="'remove'" hide-header hide-footer modal-center>
    <b-row>
      <b-col>
        <label>{{ selectedMember }}さんを名前候補から削除します。よろしいですか？</label>
      </b-col>
    </b-row>
    <b-row class="float-right">
      <b-col>
        <b-button variant="outline-secondary" class="my-2 mx-2" @click="$bvModal.hide('remove')" size="sm">やめる</b-button>
        <b-button variant="danger" class="my-2 mx-2" @click="removeName(meiboYear,selectedMember)" size="sm">名前を削除</b-button>
      </b-col>
    </b-row>
  </b-modal>
</div>
</template>

<style>
</style>

<script>
import Header from '@/components/Header.vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import router from '../router'
import 'dayjs/locale/ja'
import dayjs from 'dayjs'
var customParseFormat = require('dayjs/plugin/customParseFormat')
dayjs.extend(customParseFormat)
import config from '../config/adminUsersEmail'
import {
  ValidationProvider,
  extend
} from "vee-validate";
import {
  required,
} from "vee-validate/dist/rules";
extend('required', required);

export default {
  name: 'userManage',
  created: function() {
    this.database = firebase.database();
    this.auth = firebase.auth()
    this.uid = firebase.auth().currentUser.uid;

    // 管理者のみ、利用可能列を表に表示する
    this.config = config;
    if (this.config.adminUsersEmail.includes(firebase.auth().currentUser.email)) {
      this.fields.unshift({
        key: 'authorized',
        label: '利用可能',
      })
    }

    var _this = this;
    firebase.database().ref('users/').on("value", snapShot => {
      if (snapShot) {
        _this.userList = [];
        snapShot.forEach((data) => {
          let user = data.val();
          user["key"] = data.key;
          _this.userList.push(user);
        });
      }
    })
    this.userList.sort(function(a, b) {
      if (a.lastUpdateDate > b.lastUpdateDate) {
        return -1;
      } else {
        return 1;
      }
    });

    let meiboObserver = firebase.database().ref('meibo/')
    meiboObserver.on("value", snapShot => {
      _this.memberObject = {}
      snapShot.forEach((data) => {
        //console.log(data.val());
        let member = data.val()
        _this.memberObject[data.key] = member;
      })
      let meiboYearList = Object.keys(this.memberObject);
      _this.meiboYearList = meiboYearList;
      this.meiboYearList.reverse();
      if (this.meiboYear === "" || !this.memberObject[this.meiboYear]) {
        _this.meiboYear = meiboYearList[0];
      }
      _this.setMemberListByYear(_this.meiboYear)

    })
  },
  data() {
    return {
      config: {},
      meiboYear: "",
      memberObject: {},
      selectedMember: "",
      memberListByYear: "",
      addNewMember: false,
      memberName: "",
      memberKana: "",
      memberKyu: "",
      memberDan: "",
      nameOptions: [],
      kyuOptions: [{ text: "未選択", value: "" }, "A", "B", "C", "D", "E"],
      danOptions: [{ text: "未選択", value: "" }, "10", "9", "8", "7", "6", "5", "4", "3", "2", "初", "無"],
      userList: [],
      auth: {},
      fields: [{
          key: 'name',
          label: '名前',
          sortable: true,
        },
        {
          key: 'kana',
          label: 'かな',
          sortable: true,
        },
        {
          key: 'enterYear',
          label: '入会年次',
          sortable: true,
        },
        {
          key: 'email',
          label: 'メールアドレス',
          sortable: true,
        },
        {
          key: 'lastUpdateDate',
          label: '最終更新日',
          sortable: true,
        },
      ],
      addYear: dayjs(new Date()).format('YYYY'),
      meiboYearList: [],
      yearOptions: []
    }
  },
  computed: {

  },
  components: {
    Header,
    ValidationProvider,
  },
  methods: {
    logout() {
      firebase.auth().signOut().then(function() {
        router.push('/')
      }).catch(error => {
        console.log(error.message)
        router.push('/')
      })
    },
    update() {
      firebase.database().ref('users/' + firebase.auth().currentUser.uid).update(this.user)
    },
    updateAuthorized(key, authorizedValue) {
      firebase.database().ref('users/' + key).update({
        "authorized": authorizedValue
      })
    },
    updateMemberObject(meiboYear, memberName) {
      /*  let list = returnMemberListByYear.split(/[、,\n]/);
        this.memberObject[meiboYear] = list*/
      var appendKana = this.memberKana;
      var appendKyu = this.memberKyu;
      var appendDan = this.memberDan;
      var appendData = {
        [memberName]: {
          "kana": appendKana,
          "kyu": appendKyu,
          "dan": appendDan
        }
      };
      firebase.database().ref('meibo/' + meiboYear + "/").update(appendData);
      alert("更新しました。")
    },
    setMemberListByYear(meiboYear) {
      let memberList = this.memberObject[meiboYear]; //keyが名前の連想配列になったので
      //var List = ""
      if (memberList) {
        var memberNameList = Object.keys(memberList);
        memberNameList.push("新規登録");
        this.nameOptions = memberNameList;
        this.selectedMember = memberNameList[0];
        this.setMeiboData(meiboYear, memberNameList[0]);
        /*        for (let i = 0; i < memberList.length; i++) {
                  if (i == memberList.length - 1) {
                    List += memberList[i]
                  } else {
                    List += memberList[i] + "、"
                  }
                }*/
      }
      //  this.memberListByYear = List
    },
    addYearToMemberObject(addYear) {
      if (!this.memberObject[addYear]) {
        let year = {
          "テストユーザー（後で削除してください）": {
            "dan": "4",
            "kana": "てすとゆーざー",
            "kyu": "A"
          }
        };
        firebase.database().ref('meibo/' + addYear).update(year)
      }
    },
    removeYearFromMemberObject(addYear) {
      if (this.memberObject[addYear]) {
        if (this.memberObject[addYear].length === 1 && this.memberObject[addYear][0] === "") {
          firebase.database().ref('meibo/' + addYear + '/').remove();
          alert("削除しました。")
        } else {
          alert("該当の入会年度に含まれる人がいるので削除できません。")
        }
      }
    },
    setMeiboData(year, name) {
      if (name == "新規登録") {
        this.memberName = "";
        this.memberKana = "";
        this.memberKyu = "";
        this.memberDan = "";
      } else {
        this.memberName = name;
        this.memberKana = this.memberObject[year][name]["kana"];
        this.memberKyu = this.memberObject[year][name]["kyu"];
        this.memberDan = this.memberObject[year][name]["dan"];
      }
    },
    removeName(year, name) {
      firebase.database().ref('meibo/' + year + "/" + name).remove();
      this.$bvModal.hide('remove')
    }
  },
  filters: {
    unixtimeToDate: function(unixTime) {
      return dayjs.unix(unixTime).format('YYYY/MM/DD');
    },
  },
}
</script>
